/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SuvInputs */

const en_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const es_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const fr_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const de_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const ja_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const zh_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const ar_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيارة رياضية متعددة الأغراض (SUV)`)
};

const id_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const it_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const ru_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внедорожник`)
};

const pt_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

const ko_val_suv = /** @type {(inputs: Val_SuvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SUV`)
};

/**
* | output |
* | --- |
* | "SUV" |
*
* @param {Val_SuvInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_suv = /** @type {((inputs?: Val_SuvInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SuvInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_suv(inputs)
	if (locale === "es") return es_val_suv(inputs)
	if (locale === "fr") return fr_val_suv(inputs)
	if (locale === "de") return de_val_suv(inputs)
	if (locale === "ja") return ja_val_suv(inputs)
	if (locale === "zh") return zh_val_suv(inputs)
	if (locale === "ar") return ar_val_suv(inputs)
	if (locale === "id") return id_val_suv(inputs)
	if (locale === "it") return it_val_suv(inputs)
	if (locale === "ru") return ru_val_suv(inputs)
	if (locale === "pt") return pt_val_suv(inputs)
	return ko_val_suv(inputs)
});